import { render, staticRenderFns } from "./GoodsBottomTab.vue?vue&type=template&id=0d496b94&scoped=true&"
import script from "./GoodsBottomTab.vue?vue&type=script&lang=js&"
export * from "./GoodsBottomTab.vue?vue&type=script&lang=js&"
import style0 from "./GoodsBottomTab.vue?vue&type=style&index=0&id=0d496b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d496b94",
  null
  
)

export default component.exports